const PROD_HOST_NAMES = ['marketpay.payscale.com'];

export const getFormData = jsonData => {
  var formData = new FormData();
  Object.keys(jsonData).forEach(key => {
    if (Array.isArray(jsonData[key])) {
      formData.append(encodeURIComponent(key), encodeURIComponent(JSON.stringify(jsonData[key])));
    } else {
      formData.append(encodeURIComponent(key), encodeURIComponent(jsonData[key]));
    }
  });
  return formData;
};

export const isProduction = () => {
  return PROD_HOST_NAMES.find(host => window.location.hostname.match(host));
};
